
import { compose, hoistStatics } from 'recompose';
import PreviewImage from './PreviewImage';

const enhance = compose();

export default hoistStatics(enhance)(PreviewImage);



// WEBPACK FOOTER //
// ./src/components/previewImage/index.js